import { createGlobalState } from '@vueuse/core';
import { ref } from 'vue';
export var useGlobalState = createGlobalState(function () {
    var language = ref(undefined);
    var country = ref(undefined);
    var currency = ref(undefined);
    return {
        language: language,
        country: country,
        currency: currency,
    };
});
